export const ACTIONS = {
	UPDATE: 'UPDATE' as const,
};
